export const testimonials = [
  {
    quote:
      "Buddify transformed our business. We expanded our catalog by 300% without any inventory investment.",
    author: 'Sarah M.',
    role: 'Founder',
    company: 'StyleHaven',
    rating: 5,
  },
  {
    quote:
      "The Buddy AI Assistant increased our conversion rate by 40%. It's like having a 24/7 sales team.",
    author: 'Michael R.',
    role: 'E-commerce Manager',
    company: 'TechGear Pro',
    rating: 5,
  },
  {
    quote:
      "Finding reliable suppliers used to take weeks. With Buddify, we connected with 10 quality partners in a day.",
    author: 'Emily L.',
    role: 'Operations Lead',
    company: 'HomeStyle Co',
    rating: 5,
  },
  {
    quote:
      "The wholesale feature opened up a completely new B2B revenue stream for us. Game changer.",
    author: 'David K.',
    role: 'CEO',
    company: 'CraftSupply',
    rating: 5,
  },
  {
    quote:
      "Our exit intent catches alone recovered $15,000 in sales last month. The ROI is incredible.",
    author: 'Jessica T.',
    role: 'Marketing Director',
    company: 'BeautyBlend',
    rating: 5,
  },
  {
    quote:
      "Finally, a platform that understands what Shopify merchants actually need. Highly recommend.",
    author: 'Alex P.',
    role: 'Founder',
    company: 'ActiveWear Plus',
    rating: 5,
  },
]
